import React, { useCallback, useEffect, useRef, useState } from "react";
import useEscapeKeyDown from "../../hooks/useEscapeKeyDown";
import { Modal } from "react-bootstrap";
import axios, { buildVideoIndexerManifestUrl } from "../../API/axios";
import { Link } from "react-router-dom";
import moment from "moment";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SinglePostInteraction from "./SinglePostInteraction";
import SinglePostComment from "./SinglePostComment";
import SinglePostEngagement from "./SinglePostEngagement";
import { header, post, people } from "../../config/imagesLink";
import LikesDetails from "./LikesDetails";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import PostVideoCommon from "../PersonalProfile/PostVideoCommon";
import useLocalStorage from "use-local-storage";
import Hls from "hls.js";
import Plyr from "plyr";
import "plyr/dist/plyr.css";
import { Token } from "@mui/icons-material";
import PostComponent from "./PostComponent";
import PollCard from "./PollCard";
import { ImageWithLoader } from "@skeleton";
import { useTranslation } from "react-i18next";
import formatPostContent, {
  formatExpandedPostContent,
} from "../../utility/formatPostContent";
import shouldShowPostReadMore from "../../utility/shouldShowPostReadMore";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';

import "moment/locale/ar";
import "moment/locale/hi";
import "moment/locale/en-gb";
import { Tooltip } from "@mui/material";

const ImageSliderModal = ({ 
  setIspostmodalOpen,
  ispostmodalOpen,
  onRequestClose,
  isOpen,
  singlepostId,
  setIsfollowedComp,
  isfollowedComp,
  setIsLiked,
  isLiked,
  updateCommentCount,
  prevComments,
  AllPostListNews,
  updateCommentLike,
  setSinglePostId,
  setSinglePostContent,
  dLike,
  openModal,
  updateLikeCount,
  setDLike,
  isfollowed,
  setIsfollowed,
  sliderSettings,
  initialSlideIndex,
  setInitialSlideIndex,
  imageArray,
  setPostList,
  postList,
  updatePostLike,
  updateReplyCommentLike,
  initialPostItem,
}) => {
  const guestModeData = localStorage.getItem("guestMode");
  const [isDark, setIsDark] = useLocalStorage('isDark', false);
  const sessionId = localStorage.getItem("sessionId");
  const userUid = localStorage.getItem("userUid");
  const visibleVideoRef = useRef(null);
  const [activeVideoId, setActiveVideoId] = useState(null);
  const [isConnected, setIsConnected] = useState(false);

  const restrictedViewerTokens = localStorage.getItem("restrictedViewerToken");
  const { t } = useTranslation();
  const handleProfileImageError = (e) => {
    if (!e || !e.target) return;
    e.target.onerror = null;
    e.target.src = people.DefaultProfile;
  };

  const handleMediaImageError = (e) => {
    if (!e || !e.target) return;
    e.target.onerror = null;
    e.target.src = post.noimgavailable;
  };
  const language = localStorage.getItem("Lang");
  const localeMap = {
    en: "en",
    ar: "ar",
    hi: "hi",
  };

  const locale = localeMap[language] || "en";
  const [singlepostList, setSinglePostList] = useState("");
  const [singlepostListinfo, setSinglePostListInfo] = useState("");
  const [singlepostCommentList, setSinglePostCommentList] = useState([]);
  const [modalLoading, setModalLoading] = useState(false);
  const iframeRef = useRef(null);

  const hydrateFromFeedItem = (feedItem) => {
    if (!feedItem?.postInfo) return false;
    const feedPostId = feedItem?.postInfo?.postId ?? feedItem?.postInfo?.postInfo?.postId;
    if (!feedPostId || String(feedPostId) !== String(singlepostId)) return false;

    setSinglePostListInfo(feedItem);
    setSinglePostList({ postInfo: feedItem });
    setModalLoading(false);
    return true;
  };

  const AllPostData = async () => {
    try {
      const resData = await axios.get(
        `/Posts/GetPostInfo?DeviceType=Web&PostId=${singlepostId}&RestrictedViewerToken=${restrictedViewerTokens}&langKey=${language}`,
      );
      const responseData = resData?.data?.responseData;
      setSinglePostList(responseData);
      setSinglePostListInfo(responseData?.postInfo);
    } catch (error) {
      console.log(error);
    } finally {
      setModalLoading(false);
    }
  };

  const AllPostComments = async () => {
    try {
      const resData = await axios.get(
        `/Posts/LoadAllComments?DeviceType=Web&PostId=${singlepostId}&langKey=${language}`,
      );
      setSinglePostCommentList(resData?.data?.responseData ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const AllPostList = () => {
    void AllPostData();
    void AllPostComments();
  };

  // Prefer feed imageArray (full list on open); fall back to GetPostInfo media
  const apiMediaList = singlepostListinfo?.postInfo?.mediaFilesList || [];
  const feedMediaList = Array.isArray(imageArray) ? imageArray : [];
  const mediaFilesList =
    feedMediaList.length >= apiMediaList.length && feedMediaList.length > 0
      ? feedMediaList
      : apiMediaList.length > 0
        ? apiMediaList
        : feedMediaList;

  const getMediaSrc = (media) =>
    typeof media === "string" ? media : media?.mediaName;

  const hasMultipleImages = mediaFilesList.length > 1;
  const isVideoPost =
    singlepostListinfo?.cntntTypCategory === "TextWithVideo" ||
    singlepostListinfo?.cntntTypCategory === "Video";
  const contentType = singlepostListinfo?.cntntTypCategory;
  const expectsImageMedia =
    contentType === "Image" ||
    contentType === "TextWithImage" ||
    contentType === "UserStory" ||
    (Array.isArray(mediaFilesList) && mediaFilesList.length > 0);
  const primaryMediaSrc = getMediaSrc(mediaFilesList[0]);
  const showModalImage =
    !isVideoPost && (Boolean(primaryMediaSrc) || expectsImageMedia);

  const settings = {
    dots: false,
    arrows: hasMultipleImages,
    infinite: hasMultipleImages,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: initialSlideIndex || 0,
  };

  const [showModal, setShowModal] = useState(false);
  const [postLikedType, setPostLikedType] = useState(false);
  const [postId, setPostId] = useState("");
  const [expandedPosts, setExpandedPosts] = useState({});
  const [postContentMap, setPostContentMap] = useState({});

  const handleShowModal = (item) => {
    setPostId(item.postId);
    setPostLikedType(item.likedType);
    setShowModal(true);
  };

  const handleLikesCloseModal = () => {
    setShowModal(false);
  };

  const handleCloseModal = useCallback(() => {
    if (showModal) {
      setShowModal(false);
      return;
    }

    onRequestClose({
      postId: singlepostListinfo?.postInfo?.postId || singlepostId,
      postSnapshot: singlepostListinfo,
      commentsSnapshot: singlepostCommentList,
    });
    setIspostmodalOpen(false);
    setSinglePostId("");
    setInitialSlideIndex(0);
  }, [
    showModal,
    onRequestClose,
    singlepostListinfo,
    singlepostCommentList,
    singlepostId,
    setIspostmodalOpen,
    setSinglePostId,
    setInitialSlideIndex,
  ]);

  useEscapeKeyDown(isOpen, handleCloseModal);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleKeyDown = (e) => {
      if (e.key === "ArrowLeft") {
        document.querySelector(".slick-prev")?.click();
      } else if (e.key === "ArrowRight") {
        document.querySelector(".slick-next")?.click();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isOpen]);


  // Hide body scroll when modal is open using a CSS class
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('imageslider-modal-open');
    } else {
      document.body.classList.remove('imageslider-modal-open');
    }
    
    return () => {
      document.body.classList.remove('imageslider-modal-open');
    };
  }, [isOpen]);

  const processExpandedContent = formatExpandedPostContent;

  const readMore = async (id) => {
    try {
      if (postContentMap[id]) {
        setExpandedPosts((prev) => ({ ...prev, [id]: true }));
        return;
      }

      const res = await axios.get(
        `/Posts/GetPostMainContent?DeviceType=Web&PostId=${id}&langKey=${language}`
      );

      setPostContentMap((prev) => ({
        ...prev,
        [id]: res.data.responseData,
      }));

      setExpandedPosts((prev) => ({
        ...prev,
        [id]: true,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const formattedContent = formatPostContent(
    singlepostListinfo?.postInfo?.postContent,
    singlepostListinfo?.postInfo?.dynamicValues
  );

  useEffect(() => {
    if (!isOpen || !singlepostId) return;

    const hydrated = hydrateFromFeedItem(initialPostItem);
    if (!hydrated) {
      setModalLoading(true);
    }

    AllPostList();
  }, [singlepostId, isOpen, initialPostItem]);

  const reloadVideo = () => {
    // console.log("hiiiiiiiiiiiiiiii");

    const iframe = iframeRef.current;
    if (iframe) {
      // Force reload by resetting src
      const originalSrc = iframe.src;
      iframe.src = '';
      setTimeout(() => {
        iframe.src = originalSrc;
      }, 100); // small delay ensures reload
    }
  };

  const videoRef = useRef(null);
  // const sharedVideoRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    const videoId = singlepostListinfo?.postInfo?.mediaFilesList?.[0]?.mediaInfo;
    // const accountId = "3933d146-5f68-41d4-93a3-d2f7454d4a8d";
    const region = "centralindia";

    console.log("videoId:", videoId);
    // console.log("token:", restrictedViewerToken);

    if (!videoId || !restrictedViewerTokens || !videoRef.current) {
      console.error("Missing videoId or token or ref.");
      return;
    }

    const manifestUrl = buildVideoIndexerManifestUrl({ videoId: videoId, accessToken: restrictedViewerTokens });
    // console.log("manifestUrl:", manifestUrl);
    let hls;
    let plyrInstance;

    if (Hls.isSupported()) {
      hls = new Hls();
      hls.loadSource(manifestUrl);
      hls.attachMedia(videoRef.current);

      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        console.log("Manifest parsed");
        plyrInstance = new Plyr(videoRef.current, {
          captions: { active: true, update: true, language: "en" },
        });

        // Wait for a short time, then try to play
        videoRef.muted = true; // always start muted
        videoRef.current?.play().catch(err => {
          console.warn("Play interrupted", err);
        });

      });

      hls.on(Hls.Events.ERROR, (event, data) => {
        console.error("HLS.js Error:", data);
      });
    } else if (videoRef.current.canPlayType("application/vnd.apple.mpegurl")) {
      console.log(" Native HLS fallback");
      videoRef.current.src = manifestUrl;
      // plyrInstance = new Plyr(videoRef.current);
      videoRef.current.addEventListener("loadedmetadata", () => {
        videoRef.current?.play();
      });
    }
    return () => {
      // if (plyrInstance) plyrInstance.destroy();
      if (hls) hls.destroy();
    };
  }, [ispostmodalOpen, restrictedViewerTokens]);


  const shouldShowModal =
    isOpen && singlepostListinfo?.cntntTypCategory && singlepostListinfo?.postInfo;

  console.log("singadhfsdas", singlepostListinfo);

  const getRelativeTime = (singlepostListinfo) => {
    const now = moment.utc().local();
    const itemTime = moment
      .utc(singlepostListinfo?.postInfo?.creationTime)
      .local();

    const diffSeconds = now.diff(itemTime, "seconds");
    const diffMinutes = now.diff(itemTime, "minutes");
    const diffHours = now.diff(itemTime, "hours");
    const diffDays = now.diff(itemTime, "days");
    const diffMonths = now.diff(itemTime, "months", true);
    const diffYears = now.diff(itemTime, "years", true);

    /* JUST NOW */
    if (diffSeconds < 60) {
      return t("Notifications.Just Now");
    }

    /* MINUTES */
    if (diffMinutes < 60) {
      return diffMinutes === 1
        ? `${diffMinutes} ${t("Notifications.Minute")} ${t("Notifications.Ago")}`
        : `${diffMinutes} ${t("Notifications.Minutes")} ${t("Notifications.Ago")}`;
    }

    /* HOURS */
    if (diffHours < 24) {
      return diffHours === 1
        ? `${diffHours} ${t("Notifications.Hour")} ${t("Notifications.Ago")}`
        : `${diffHours} ${t("Notifications.Hours")} ${t("Notifications.Ago")}`;
    }

    /* DAYS */
    if (diffDays < 30) {
      return diffDays === 1
        ? `${diffDays} ${t("Notifications.Day")} ${t("Notifications.Ago")}`
        : `${diffDays} ${t("Notifications.Days")} ${t("Notifications.Ago")}`;
    }

    /* MONTHS */
    if (diffMonths < 12) {
      const displayMonth =
        diffMonths >= 0.75 && diffMonths < 1.25
          ? 1
          : Math.round(diffMonths * 2) / 2;

      return displayMonth === 1
        ? `${t("Notifications.PostedAround")} ${displayMonth} ${t("Notifications.Month")} ${t("Notifications.Ago")}`
        : `${t("Notifications.PostedAround")} ${displayMonth} ${t("Notifications.Months")} ${t("Notifications.Ago")}`;
    }

    /* YEARS */
    const displayYear =
      diffYears >= 0.75 && diffYears < 1.25
        ? 1
        : Math.round(diffYears * 2) / 2;

    return displayYear === 1
      ? `${t("Notifications.PostedAround")} ${displayYear} ${t("Notifications.Year")} ${t("Notifications.Ago")}`
      : `${t("Notifications.PostedAround")} ${displayYear} ${t("Notifications.Years")} ${t("Notifications.Ago")}`;
  };


  return (
    <>


      {/* {console.log("singlepostListinfo", singlepostListinfo)} */}

      {/* {isOpen && ( */}
      <div
        className={`${singlepostListinfo?.cntntTypCategory === "Text" ? "modal-md" : "modal-xl"
          } modal fade show postAdd`}
        // className={`
        //   ${Array.isArray(singlepostListinfo?.postInfo?.mediaFilesList) ||
        //   singlepostListinfo?.postInfo?.mediaFilesList?.length === 0
        //   ? "modal-xl"
        //   : "modal-md"
        //   } modal fade show postAdd`}
        tabIndex="-1"
        role="dialog"
        style={{ display: "block" }}
      >
        <div
          className="modal-dialog modal-dialog-centered m-auto"
          role="document"
          style={{ height: "100vh" }}
        >
          <div
            className="modal-content ImagesliderScroller d-flex flex-column m-auto MobileCommentmodal"
            style={{ overflowY: "auto", height: "100vh" }}
          >
            <div className="modalBorder d-flex justify-content-between align-items-center p-3">
              {isDark ? (
                <div className="Logo">
                  <img src={header.whiteoglogo} alt="" width={130} />
                </div>
              ) : (
                <div className="Logo">
                  <img src={header.oglogo} alt="" width={130} />
                </div>
              )}
              <CloseSharpIcon
                className="material-symbols-sharp me-2 pointer"
                role="button"
                aria-label={t("modals.Close") || "Close"}
                tabIndex={0}
                onClick={handleCloseModal}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    handleCloseModal();
                  }
                }}
              />
            </div>

            {modalLoading && !singlepostListinfo?.postInfo ? (
              <div className="d-flex justify-content-center align-items-center w-100 flex-grow-1">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">{t("modals.Loading")}</span>
                </div>
              </div>
            ) : (
              <>

                <div className="row w-100 m-0 image-slider-modal-row">
                  <div
                    className={`${singlepostListinfo?.cntntTypCategory === "Text"
                      ? "d-none"
                      : "col-12 col-lg-7"
                      } p-0 image-slider-media-col`}
                  >
                    <div className="image-slider-modal commentSection text-center">
                      {!isVideoPost && hasMultipleImages ? (
                        <Slider
                          key={`${singlepostId}-${mediaFilesList.length}-${initialSlideIndex}`}
                          {...settings}
                        >
                          {mediaFilesList.map((image, index) => (
                            <div key={`${getMediaSrc(image) || "media"}-${index}`}>
                              <ImageWithLoader
                                src={getMediaSrc(image) || post.noimgavailable}
                                alt={`Slide ${index + 1}`}
                                className="img-fluid m-auto modal-image"
                                onError={handleMediaImageError}
                              />
                            </div>
                          ))}
                        </Slider>
                      ) : (
                        <>
                          {showModalImage ? (
                            <ImageWithLoader
                              src={primaryMediaSrc || post.noimgavailable}
                              alt=""
                              className="img-fluid"
                              width="100%"
                              onError={handleMediaImageError}
                            />
                          ) : null}

                          {isVideoPost &&
                            singlepostListinfo?.postInfo?.mediaFilesList?.[0]
                              ?.mediaInfo ? (
                            <div

                              style={{
                                paddingBottom: "50px",
                              }}>
                              <PostVideoCommon
                                file={singlepostListinfo?.postInfo?.mediaFilesList?.[0]}
                                item={singlepostListinfo}
                                restrictedViewerToken={restrictedViewerTokens}
                                setActiveVideoId={setActiveVideoId}
                                activeVideoId={activeVideoId}
                                AllPostList={AllPostList}
                                setPostList={setPostList}
                                visibleVideoRef={visibleVideoRef} />
                            </div>
                          ) : !isVideoPost && !showModalImage ? (
                            <>
                              <PostComponent item={singlepostListinfo} restrictedViewerToken={restrictedViewerTokens} isOpen={isOpen} isModalView={true} />
                            </>
                          ) : null}
                        </>
                      )}
                    </div>
                  </div>

                  <div
                    className={`${singlepostListinfo?.cntntTypCategory === "Text"
                      ? "col-12"
                      : "col-12 col-lg-5"
                      } p-0 ModifyScrollBar image-slider-details-col`}
                  // className={` ${Array.isArray(singlepostListinfo?.postInfo?.mediaFilesList) ||
                  //   singlepostListinfo?.postInfo?.mediaFilesList?.length === 0
                  //   ? "col-md-4"
                  //   : "col-md-12"
                  //   } p-0`}
                  >
                    <div className="featured-card user-postOnlyContent p-2 m-2">
                      <div className="feature-content p-2 d-flex justify-content-between">
                        <Link to={singlepostListinfo?.postInfo?.postOriginType === "Company" ? `/Company/${singlepostListinfo?.postInfo?.userUid}` : `/User/${singlepostListinfo?.postInfo?.userUid}`}>
                          <div className="d-flex align-items-center">
                            <div className="ImgAvatar">
                              <img
                                src={singlepostListinfo?.postInfo?.userAvatar || people.DefaultProfile}
                                alt=""
                                style={{ borderRadius: "50px" }}
                                onError={handleProfileImageError}
                              />
                            </div>
                            <div className="ms-2">
                              <h4 className="f-14 fw-bold mb-0">
                                {singlepostListinfo?.postInfo?.userName}
                              </h4>
                              {/* <p className="f-12">
                                  {moment
                                    .utc(singlepostList?.postInfo?.postInfo?.creationTime)
                                    .local()
                                    .format("DD MMMM YYYY [at] h:mm a")}
                                </p> */}
                              {language === "ar" ? (
                                <Tooltip title={moment
                                  .utc(singlepostList?.postInfo?.postInfo?.creationTime)
                                  .locale(locale)
                                  .local()
                                  .format("D MMMM YYYY [الساعة] h:mm a")} arrow>
                                  <p className="f-10 label">
                                    {moment
                                      .utc(singlepostList?.postInfo?.postInfo?.creationTime)
                                      .locale(locale)
                                      .local()
                                      .format("D MMMM YYYY [الساعة] h:mm a")}
                                  </p>
                                </Tooltip>
                              ) : (
                                <Tooltip title={moment
                                  .utc(singlepostList?.postInfo?.postInfo?.creationTime)
                                  .local()
                                  .format(language === "en"
                                    ? "D MMMM YYYY [at] h:mm a"
                                    : "D MMMM YYYY [को] h:mm a")} arrow>
                                  <p className="f-10 label">
                                    {getRelativeTime(singlepostListinfo)}</p>
                                </Tooltip>


                              )}

                            </div>
                          </div>
                        </Link>
                        {guestModeData === "true" ? null : (
                          <div className="row">
                            <div>
                              <SinglePostInteraction
                                postId={singlepostListinfo?.postInfo?.postId}
                                AllPostComments={AllPostComments}
                                AllPostList={AllPostList}
                                singlepostList={singlepostListinfo?.postInfo}
                                singlepostListData={singlepostListinfo}
                                AllPostListNews={AllPostListNews}
                                setSinglePostList={setSinglePostList}
                                PostOriginType={"User"}
                                postOriginId={userUid}
                                isfollowedComp={isfollowedComp}
                                setIsfollowedComp={setIsfollowedComp}
                                setIsConnected={setIsConnected}
                                isConnected={isConnected}
                                isfollowed={isfollowed}
                                setIsfollowed={setIsfollowed}
                                setPostList={setPostList}
                              />
                            </div>
                          </div>
                        )}
                      </div>

                      {singlepostListinfo?.postInfo?.postContent && (
                        <div className="f-14 p-2 postContent">
                          <>
                            {!expandedPosts?.[singlepostListinfo?.postInfo?.postId] && (
                              <div
                                className="postContentDiv"
                                dangerouslySetInnerHTML={{
                                  __html: formattedContent,
                                }}
                              />
                            )}

                            {!expandedPosts?.[singlepostListinfo?.postInfo?.postId] &&
                              shouldShowPostReadMore(
                                singlepostListinfo?.postInfo?.postContent,
                                singlepostListinfo?.postInfo?.readMore
                              ) && (
                                <span style={{ color: "#1051b0" }}
                                  onClick={() => readMore(singlepostListinfo?.postInfo?.postId)}
                                  className="pointer"
                                >
                                  {t("Newsfeed.Read More")}
                                </span>
                              )}

                            {expandedPosts?.[singlepostListinfo?.postInfo?.postId] &&
                              postContentMap?.[singlepostListinfo?.postInfo?.postId] && (
                                <div
                                  className="postContentDiv f-14"
                                  dangerouslySetInnerHTML={{
                                    __html: processExpandedContent(
                                      postContentMap[singlepostListinfo?.postInfo?.postId],
                                      singlepostListinfo?.postInfo?.dynamicValues
                                    ),
                                  }}
                                />
                              )}

                            {expandedPosts?.[singlepostListinfo?.postInfo?.postId] && (
                              <span style={{ color: "#1051b0" }}
                                className="pointer"
                                onClick={() =>
                                  setExpandedPosts((prev) => ({
                                    ...prev,
                                    [singlepostListinfo?.postInfo?.postId]: false,
                                  }))
                                }
                              >
                                {t("Newsfeed.Read Less")}
                              </span>
                            )}
                          </>
                        </div>
                      )}

                      {singlepostListinfo?.postInfo?.postId && (
                        <div className="px-2 pb-1">
                          <PollCard postId={singlepostListinfo.postInfo.postId} eager />
                        </div>
                      )}

                      <div className="feed-post p-2">
                        {guestModeData === "true" ? null : (
                          <div className="row">
                            <div className="addComment">
                              <SinglePostComment
                                isOwnedPost={singlepostListinfo?.postInfo?.isOwned}
                                postId={singlepostListinfo?.postInfo?.postId}
                                AllPostList={AllPostList}
                                singlepostList={singlepostList}
                                setSinglePostList={setSinglePostList}
                                AllPostComments={AllPostComments}
                                ispostmodalOpen={ispostmodalOpen}
                                setIspostmodalOpen={setIspostmodalOpen}
                                setPostList={setPostList}
                                setSinglePostCommentList={setSinglePostCommentList}
                                singlepostCommentList={singlepostCommentList}
                                videoRef={videoRef}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                      <div
                        className={`postData d-flex align-items-center justify-content-between ${singlepostListinfo?.postInfo?.likeCount === 0 &&
                          singlepostListinfo?.commentCount === 0 &&
                          singlepostList?.postInfo?.postInfo?.shareCount === 0
                          ? ""
                          : "border-custom1"
                          }`}
                        style={{
                          direction: language === "ar" ? "rtl" : "ltr",
                          textAlign: language === "ar" ? "right" : "left",
                        }}
                      >
                        <div className="ms-2">
                          {singlepostListinfo?.postInfo?.likeCount === 0 || singlepostListinfo?.postInfo?.likeCount === null ? (
                            ""
                          ) : (
                            <p
                              className="f-10 pointer like-details"
                              onClick={() => handleShowModal(singlepostListinfo)}
                            >
                              {singlepostListinfo?.postInfo?.likeCount} <ThumbUpOutlinedIcon style={{ color: "#00419f", fontSize: "13px" }} />
                              {/* {t("Newsfeed.Like")} */}
                            </p>
                          )}
                        </div>
                        <div className=" d-flex">
                          {(singlepostListinfo?.postInfo?.commentCount ?? 0) > 0 && (
                            <p className="f-10 me-2 pointer like-details">
                              {singlepostCommentList?.length > 0
                                ? singlepostCommentList.length
                                : singlepostListinfo?.postInfo?.commentCount}{" "}
                              <ChatOutlinedIcon
                                style={{ color: "#00419f", fontSize: "13px" }} />
                            </p>
                          )}

                          {(singlepostListinfo?.postInfo?.shareCount ?? 0) > 0 && (
                            <p className="f-10">
                              & {singlepostListinfo.postInfo.shareCount} {t("Newsfeed.Share")}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="postengagement">
                        <SinglePostEngagement
                          setIsLiked={setIsLiked}
                          isLiked={isLiked}
                          isOwnedPost={singlepostListinfo?.postInfo?.isOwned}
                          AllPostComments={AllPostComments}
                          updateCommentCount={updateCommentCount}
                          postId={singlepostListinfo?.postInfo?.postId}
                          AllPostList={AllPostList}
                          AllPostData={AllPostData}
                          postList={postList}
                          singlepostListinfo={singlepostListinfo}
                          setSinglePostListInfo={setSinglePostListInfo}
                          singlepostList={singlepostList}
                          setSinglePostList={setSinglePostList}
                          ispostmodalOpen={ispostmodalOpen}
                          setIspostmodalOpen={setIspostmodalOpen}
                          openModal={openModal}
                          setSinglePostId={setSinglePostId}
                          setSinglePostContent={setSinglePostContent}
                          setDLike={setDLike}
                          updateLikeCount={updateLikeCount}
                          setPostList={setPostList}
                          setSinglePostCommentList={setSinglePostCommentList}
                          singlepostCommentList={singlepostCommentList}
                          updateCommentLike={updateCommentLike}
                          updatePostLike={updatePostLike}
                          updateReplyCommentLike={updateReplyCommentLike}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {/* )} */}

      {/* {showModal && ( */}
      <LikesDetails
        showModal={showModal}
        handleLikesCloseModal={handleLikesCloseModal}
        postId={singlepostListinfo?.postInfo?.postId}
        postLikedType={postLikedType}
      />
      {/* )} */}
    </>
  );
};

export default ImageSliderModal;